var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4521 12.8262C16.7021 12.8262 12.9521 12.8262 12.9521 9.07617C12.9521 8.08161 13.3472 7.12778 14.0505 6.42452C14.7538 5.72126 15.7076 5.32617 16.7021 5.32617C20.4521 5.32617 20.4521 10.3262 20.4521 12.8262Z",
    stroke: "currentColor",
    strokeWidth: 1.22619
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4521 12.8262C24.2021 12.8262 27.9521 12.8262 27.9521 9.07617C27.9521 8.08161 27.5571 7.12778 26.8538 6.42452C26.1505 5.72126 25.1967 5.32617 24.2021 5.32617C20.4521 5.32617 20.4521 10.3262 20.4521 12.8262Z",
    stroke: "currentColor",
    strokeWidth: 1.22619
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95215 20.3262V35.3262H32.9522V20.3262",
    stroke: "currentColor",
    strokeWidth: 1.22619
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4531 12.8242H5.45312V20.3242H35.4531V12.8242Z",
    stroke: "currentColor",
    strokeWidth: 1.22619
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4521 12.8242V35.3242",
    stroke: "currentColor",
    strokeWidth: 1.22619
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.2ee6adeaa3404b7f504e68879a8e3fbd.svg";
export { ForwardRef as ReactComponent };